import script from "./CopySharedLinkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CopySharedLinkModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__